export default "__VITE_ASSET__oFHEmZFS__"